import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from './../../../app.config';
import 'rxjs/Rx';

/**
 * Definição da classe.
 */
@Injectable()
export class FormularioRelatorioService {
    

    /**
     * URL da api.
     */
    private baseUrl:string = AppConfig.API_URL + '/formulario/relatorio';

    /**
     * Construtor.
     */
    constructor(private http: HttpClient) { }

    /**
     * Salvar um relatorio.
     */
    public saveRelatorio( rel ):any {
        return this.http.post(this.baseUrl, rel);
    }

    /**
     * Atualizar um relatorio.
     */
    public updateRelatorio( rel ):any {
        return this.http.put(this.baseUrl, rel);
    }

    /**
     * Busca por id do sistema.
     */
    public findByIdSistema( id ):any {
        return this.http.get(this.baseUrl+'/sistema/'+id);
    }
    
    /**
     * Busca todos os schemas.
     */
    public findAll( ):any { 
        return this.http.get(this.baseUrl);
    }
    
    /**
     * Deletar por id.
     */
    public delete( id ):any {     
        return this.http.delete(this.baseUrl+'/'+id);
    }

    /**
     * Busca por id.
     */
    public findById( id ):any {     
        return this.http.get(this.baseUrl+'/'+id);
    }
    
}
